/**
 * Knowledge Base Service - Handles API interactions for knowledge base management
 */

import { post, put } from "../utils/apiUtils";


// No need to use BASE_URL as it's already configured in apiUtils.js
const API_URL = `/api/v1/mms_persistence/entity`;
const ENTITY_CONFIG_URL = `/api/v1/mms_ai_configs/entities/config`


/**
 * Get all Entities bases with optional filtering
 * @param {Object} filters - Filter parameters
 * @param {Object} sort - Sort parameters
 * @returns {Promise<Array>} Promise resolving to array of knowledge bases
 */
export const getAllEntitiesByFilter = async (filter = {}, sort ={}, query =null) => {
  try {
    const response = await post(`${API_URL}/fetch?${query}`, { filter: filter,sort });
    return response;
  } catch (error) {
    console.error('Error fetching knowledge bases:', error);
    throw error;
  }
};

/**
 * Get all Entities bases with optional filtering
 * @param {Object} filters - Filter parameters
 * @param {Object} sort - Sort parameters
 * @returns {Promise<Array>} Promise resolving to array of knowledge bases
 */
export const listAllEntities = async (tableName,filter = {}, sort ={}, query =null) => {
  try {
    const response = await post(`/api/v1/mms_persistence/${tableName}/fetch?${query}`, { filter: filter,sort });
    return response;
  } catch (error) {
    console.error('Error fetching knowledge bases:', error);
    throw error;
  }
};

/**
 * Get a specific entity by ID
 * @param {string} entityId - entity ID
 * @returns {Promise<Object>} Promise resolving to entity object
 */
export const getEntityById = async (entityId) => {
  let filter = {
    id: entityId
  }
  let sort ={}
  try {
    const response = await post(`${API_URL}/fetch?query=null`, { filter, sort });
    if(response && response.length > 0) {
      return response[0];
    }else{
      return null;
    }
  } catch (error) {
    console.error('Error fetching knowledge bases:', error);
    throw error;
  }
};


/**
 * Update a specific entity
 * @param {string} entity - entity
 * @returns {Promise<Object>} Promise resolving to entity object
 */
export const updateEntity = async (entity) => {
  
  try {
    const response = await put(`${API_URL}`, entity);
    return response;
  } catch (error) {
    console.error('Error fetching knowledge bases:', error);
    throw error;
  }
};


/**
 * Update a specific entity
 * @param {string} entity - entity
 * @returns {Promise<Object>} Promise resolving to entity object
 */
export const createEntity = async (entity) => {
  
  try {
    const response = await post(`${API_URL}`, entity);
    return response;
  } catch (error) {
    console.error('Error fetching knowledge bases:', error);
    throw error;
  }
};


/**
 * Update a specific entity
 * @param {string} entity - entity
 * @returns {Promise<Object>} Promise resolving to entity object
 */
export const fetchEntityCount = async (filter) => {
  
  try {
    const response = await post(`${ENTITY_CONFIG_URL}/count`, {filter});
    return response;
  } catch (error) {
    console.error('Error fetching entity:', error);
    throw error;
  }
};


/**
 * Get all Entities bases with optional filtering
 * @param {Object} filters - Filter parameters
 * @param {Object} sort - Sort parameters
 * @returns {Promise<Array>} Promise resolving to array of knowledge bases
 */
export const _getAllEntitiesByFilter = async (filter = {}, sort ={}, query = {}) => {
  try {
    const {limit = 10, skip = 0} = query;

    const response = await post(`${ENTITY_CONFIG_URL}/fetch?`, { filter ,sort, limit, skip});
    return response;
  } catch (error) {
    console.error('Error fetching knowledge bases:', error);
    throw error;
  }
};


/**
 * FetchCOunt
 * @param {string} table_name - 
 * @returns {Promise<Object>} Promise resolving to entity object
 */
export const fetchCountByFilter = async (table_name, query) => {
  // Create a request key based on the table name
  // (removed unused requestId generation)
  const tableKey = `${table_name}${JSON.stringify(query)}`

  
  // Store active requests in this map to prevent duplicates
  if (!window._activeCountRequests) {
    window._activeCountRequests = new Map();
  }
  
  // If an identical request is already in progress, cancel this one
  if (window._activeCountRequests.has(tableKey)) {
    console.log(`Duplicate count request for ${tableKey} detected, using existing request`);
    return window._activeCountRequests.get(tableKey);
  }
  
  // Create a new promise for this request
  const countPromise = new Promise(async (resolve, reject) => {
    try {
      const response = await post(`/api/v1/mms_persistence/${table_name}/count`, query);
      window._activeCountRequests.delete(tableKey);
      resolve(response.count);
    } catch (error) {
      // Check if this is a canceled request error
      if (error.name === 'CanceledError' || (error.message && error.message.includes('canceled'))) {
        console.log(`Request for ${tableKey} was canceled, likely a duplicate`);
        resolve(0); // Return a safe default value
      } else {
        console.error(`Error fetching count for ${tableKey}:`, error);
        window._activeCountRequests.delete(tableKey);
        reject(error);
      }
    }
  });
  
  // Store this promise
  window._activeCountRequests.set(tableKey, countPromise);
  
  return countPromise;
};





export default {
  getAllEntitiesByFilter,
  getEntityById,
  updateEntity,
  createEntity,
  fetchEntityCount,
  fetchCountByFilter
};
